import { render, staticRenderFns } from "./SettingsTopBar.vue?vue&type=template&id=a6839162&scoped=true"
import script from "./SettingsTopBar.vue?vue&type=script&lang=ts"
export * from "./SettingsTopBar.vue?vue&type=script&lang=ts"
import style0 from "./SettingsTopBar.vue?vue&type=style&index=0&id=a6839162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6839162",
  null
  
)

export default component.exports